"use client";

import * as All from '@/element/common/elmntbase';
import Link from 'next/link';
import Nimage from './image';
import { useState, useEffect } from 'react';

export default function PortfolioLoadMore({ tabId, tabContent, allTabId, _data }: {
  tabId: string;
  tabContent: any;
  allTabId: string;
  _data: any;
}) {
  const [visibleCount, setVisibleCount] = useState(3);

  const handleLoadMore = (e: any) => {
    e.preventDefault();
    setVisibleCount((prev) => prev + 3);
  };

  const filteredContent = tabContent.filter((item: any) => {
    return tabId === allTabId || item.tabcontentid1747467817 === tabId;
  });

  const visibleItems = filteredContent.slice(0, visibleCount);

  return (
    <>
      <div className="projects">
        <div className="row align-items-center">
          {visibleItems.map((__rcd: any, _k: number) => (
            <div key={_data?.uid + _k} className={`${__rcd?.gridclass1747485263}`}>
              {__rcd?.projectlink1747467846 ?
                <Link href={__rcd?.projectlink1747467846} className="project-card">
                  <div className={`img ${__rcd?.imageclass1747484783}`}>
                    {__rcd?.projectimage1747467877?.length > 0 ? __rcd?.projectimage1747467877.map((immg: any, index: any) => (
                      <Nimage key={_data?.uid + immg?.url + index + 'projectimage1747467877'} immg={immg} data={_data} className="img-cover" />
                    )) : null}
                    <div className="play-btn">{_data?.arrowimage1747467960?.length > 0 ? _data?.arrowimage1747467960.map((immg: any, index: any) => (
                      <Nimage key={_data?.uid + immg?.url + index + 'arrowimage1747467960'} immg={immg} data={_data} className="ico" />
                    )) : null}</div>
                  </div>
                  <div className="info">
                    <h6 className="project-title">{__rcd?.projecttitle1747467910}</h6>
                    {/* <div className="date fsz-16 cr-777">
                    {__rcd?.projectdate1747485501 ? new Date(__rcd.projectdate1747485501).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric"
                    }) : null}
                  </div> */}
                    <div className="date fsz-16 cr-777">
                      {__rcd?.technologytitle1764334197}
                    </div>
                    <span className="num"> 0{_k + 1} </span>
                  </div>
                </Link>
                :
                <div className="project-card no-link">
                  <div className={`img ${__rcd?.imageclass1747484783}`}>
                    {__rcd?.projectimage1747467877?.length > 0 ? __rcd?.projectimage1747467877.map((immg: any, index: any) => (
                      <Nimage key={_data?.uid + immg?.url + index + 'projectimage1747467877'} immg={immg} data={_data} className="img-cover" />
                    )) : null}
                    {__rcd?.projectdescription1764334222 ? 
                      <div className="hover_info">
                        <div dangerouslySetInnerHTML={{ __html: __rcd?.projectdescription1764334222 }}></div>
                      </div>                    
                    :null}
                  </div>
                  <div className="info">
                    <h6 className="project-title">{__rcd?.projecttitle1747467910}</h6>
                    {/* <div className="date fsz-16 cr-777">
                    {__rcd?.projectdate1747485501 ? new Date(__rcd.projectdate1747485501).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric"
                    }) : null}
                  </div> */}
                    <div className="date fsz-16 cr-777">
                      {__rcd?.technologytitle1764334197}
                    </div>
                    <span className="num"> 0{_k + 1} </span>
                  </div>
                </div>
              }

            </div>
          ))}
        </div>
      </div>
      {visibleCount < filteredContent.length && (
        <div className="text-center mt-4">
          <Link href="#" className="cir-butn line-butn load_more" onClick={handleLoadMore}>
            <div className="cont"> <span className="txt fsz-20 fw-bold"> {_data?.loadmorebuttontext1747663361}</span>
              {_data?.loadmorearrow1747663702?.length > 0 ? _data?.loadmorearrow1747663702.map((immg: any, index: any) => (
                <Nimage key={_data?.uid + immg?.url + index + 'loadmorearrow1747663702'} immg={immg} data={_data} className="arrow" />
              )) : null}</div>
          </Link>
        </div>
      )}

    </>
  );
};
